<template>
  <el-dialog class="assign-exam-popup" :visible.sync="show" width="600px" center>
    <template #title>设置考试内容</template>

    <template #default>
      <el-form inline>
        <el-form-item label="考试名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="开始日期">
          <el-date-picker v-model="form.start_datetime"></el-date-picker>
        </el-form-item>

        <el-form-item label="考试时间">
          <el-time-picker format="HH:mm" v-model="time"></el-time-picker>
        </el-form-item>

        <el-form-item label="考试时长">
          <el-select v-model="duration">
            <el-option v-for="item in durationOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="每题分值">
          <el-select v-model="form.question_score">
            <el-option v-for="item in scoreOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="选择班级">
          <el-cascader
            v-model="form.class_id_list"
            :options="clazzOptions"
            placeholder="请选择班级"
            collapse-tags
            :props="{ multiple: true }"
            clearable
          ></el-cascader>
        </el-form-item>

        <el-form-item label="总分">
          <div class="total-score">{{ totalScore }}</div>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button @click="back">上一步</el-button>
        <el-button type="primary" @click="assign">确认布置</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { BaseComponent, Component, Emit, Prop, PropSync, Watch } from 'kuaidong-component'
import { Clazz, ICreateExamOrChallengeForm } from 'kuaidong-model'
import { DateUtil, DateWrapper, Debounce } from 'kuaidong-lib'
import { AClazz, AWinter2023 } from 'kuaidong-api'
import { ClassService } from 'kuaidong-service'
@Component({
  components: {},
})
export default class AssignExamPopup extends BaseComponent {
  @PropSync('visible', { type: Boolean, default: false })
  show!: boolean

  @Prop({ type: String, required: true })
  id!: string

  @Prop({ type: String, required: true })
  name!: string

  @Prop({ type: String, required: true })
  totalQuestions!: string

  get totalScore() {
    return `${+this.totalQuestions * (this.form.question_score as number)}分`
  }

  get clazzOptions() {
    return ClassService.buildClassOptionsWithNoteName(this.clazzes)
  }

  duration = 120
  form: ICreateExamOrChallengeForm = {
    paper_id: this.id,
    paper_type: 'EXAM',
    name: '',
    start_datetime: new Date(),
    end_datetime: null,
    question_score: 2,
    class_id_list: [],
    grade_ids: [],
  }

  clazzes: Clazz[] = []

  get time() {
    return new DateWrapper(this.form.start_datetime).date
  }

  set time(time: Date) {
    this.form.start_datetime = DateUtil.mergeDateAndTime(this.form.start_datetime, new DateWrapper(time).showTimeStr)
  }

  get durationOption() {
    return [30, 60, 90, 120, 150, 180].map((n) => {
      return {
        value: n,
        label: `${n}分钟`,
      }
    })
  }

  get scoreOption() {
    const scoreRange = [1, 2, 3, 4, 5]

    return scoreRange.map((n) => {
      return {
        value: n,
        label: `${n}分`,
      }
    })
  }

  async created() {
    this.fetchClazzes()
  }

  async fetchClazzes() {
    this.clazzes = await AClazz.allMine()
  }

  formatDate(date: Date) {
    return new DateWrapper(date).showDateWeekStr
  }

  formatTime(time: string) {
    if (time) {
      return time.split(':')
    }
    return time
  }

  validate() {
    if (this.form.name === '') {
      this.$message.error('考试名称不能为空')
      return false
    }

    if (this.form.class_id_list.length === 0) {
      this.$message.error('请选择布置班级~')
      return false
    }

    const start = new DateWrapper(this.form.start_datetime)

    if (this.form.end_datetime) {
      const end = new DateWrapper(this.form.end_datetime)
      if (end.date < start.date) {
        this.$message.error('结束时间不能小于开始时间~')
        return false
      }
    } else {
      this.$message.error('请选择结束时间~')
    }

    return true
  }

  @Debounce()
  async assign() {
    if (this.validate()) {
      try {
        await AWinter2023.createExamOrChallenge({
          ...this.form,
          class_id_list: this.form.class_id_list.map((option: any) => {
            return option[1]
          }),
        })
        this.$message.success('布置成功~')
        this.$router.push({
          name: 'pe_knowledge_exam_list',
        })
      } catch (e) {
        this.$message.error('布置失败~')
      }
      this.show = false
    }
  }

  @Watch('form.start_datetime', { immediate: true })
  updateEndTimeByStart() {
    this.form.end_datetime = DateUtil.addMinutes(new DateWrapper(this.form.start_datetime).date, this.duration)
  }

  @Watch('duration', { immediate: true })
  updateEndTimeByDuration() {
    this.form.end_datetime = DateUtil.addMinutes(new DateWrapper(this.form.start_datetime).date, this.duration)
  }

  @Emit('back')
  back() {
    return
  }
}
</script>

<style lang="less">
.assign-exam-popup {
  > .el-dialog {
    padding: 0 100px;
    > .el-dialog__header {
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      color: #0a1629;
    }
    > .el-dialog__body {
      padding: 25px 0;
      > .el-form {
        > .el-form-item {
          > .el-form-item__label {
            width: 68px;
          }
          > .el-form-item__content {
            > .el-input,
            .el-select,
            .el-cascader {
              width: 300px;
            }

            > .total-score {
              color: #cbcbcb;
            }
          }
        }
      }

      > .footer {
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px;
        > .el-button {
          width: 135px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
